import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { Budget, MultiChoiceCardOrder } from '@/models/index'

@Model()
export default class BudgetMove extends ApplicationRecord {
  static jsonapiType = 'budget_moves'

  @Attr() id!: string
  @Attr() amount!: number
  @Attr() creditedAt!: string
  @Attr() sourceType!: string
  @Attr() createdAt!: string
  @Attr() movementNumber!: string
  @Attr() comment!: string
  @Attr() depositInvoiceId!: string
  @Attr() reserved!: boolean
  @Attr() multiChoiceCardOrderId!: string

  @BelongsTo() budget!: Budget
  @BelongsTo() source!: any
  @BelongsTo() multiChoiceCardOrder!: MultiChoiceCardOrder

  @Attr() kind!: string
}
